(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-home-shop"] && !Shopify.designMode) return;
  try {
    
/**
 * Shop-strip arrows. Delegated from the document rather than initialised per
 * section, so a theme-editor re-render (shopify:section:load) needs no re-init.
 * The controls ship `hidden` and are revealed only when the track actually
 * overflows — arrows that cannot scroll anything are worse than no arrows. A
 * settled four-up row therefore never shows them.
 */
(() => {
  const TRACK = '[data-shop-track]';

  function cardStep(track) {
    const card = track.querySelector('.home-shop-card');
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function sync(track) {
    const root = track.closest('.home-shop');
    if (!root) return;
    const controls = root.querySelector('[data-shop-controls]');
    if (!controls) return;
    const overflows = track.scrollWidth - track.clientWidth > 2;
    controls.hidden = !overflows;
    const prev = controls.querySelector('[data-shop-prev]');
    const next = controls.querySelector('[data-shop-next]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }

  function syncAll() {
    document.querySelectorAll(TRACK).forEach(sync);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-shop-prev], [data-shop-next]');
    if (!button) return;
    const root = button.closest('.home-shop');
    const track = root && root.querySelector(TRACK);
    if (!track) return;
    const dir = button.hasAttribute('data-shop-prev') ? -1 : 1;
    track.scrollBy({ left: dir * cardStep(track), behavior: 'smooth' });
  });

  document.addEventListener('scroll', (event) => {
    if (event.target instanceof Element && event.target.matches(TRACK)) sync(event.target);
  }, true);

  window.addEventListener('resize', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  document.addEventListener('shopify:section:load', syncAll);
  syncAll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
